/* eslint-disable react/prop-types */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, isAdmin } from '../authContext';

/**
 * Guarda de las pantallas que solo puede ver un cs-admin.
 *
 * RequireAuth ya comprobó la sesión. Acá solo queda el rol: el backend vuelve
 * a exigirlo, pero no tiene sentido pintar el panel a quien no puede usarlo.
 */
export default function RequireAdmin({ children }) {
    const { tokens } = useAuth();
    const admin = tokens ? isAdmin(tokens) : false;

    if (!admin) {
        return <Navigate to="/" replace />;
    }

    return children;
}
